import type { FC, ReactNode } from 'react'

import { Waves } from 'lucide-react'
import { siteConfig } from '@/constants/site'

const links = [
    { href: '#highlights', label: 'At BII shore' },
    { href: '#finds', label: 'SD' },
    { href: '#facts', label: 'SASAS' },
    { href: '#faq', label: 'FAQ' }
]

const SiteHeader: FC = (): ReactNode => {
    return (
        <header className='absolute inset-x-0 top-0 z-20'>
            <nav aria-label='Main' className='mx-auto flex h-20 max-w-6xl items-center justify-between px-6'>
                <a href='#hero' className='inline-flex items-center gap-2 rounded-md font-heading text-xl text-foreground focus-visible:ring-4 focus-visible:ring-ring/40 focus-visible:outline-none'>
                    <Waves aria-hidden='true' className='size-5 text-primary' />
                    {siteConfig.name}
                </a>

                <ul className='hidden items-center gap-8 text-sm font-medium text-muted-foreground md:flex'>
                    {links.map(link => (
                        <li key={link.href}>
                            <a href={link.href} className='rounded-md transition-colors hover:text-foreground focus-visible:ring-4 focus-visible:ring-ring/40 focus-visible:outline-none'>
                                {link.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </nav>
        </header>
    )
}

export default SiteHeader
